import React, { useMemo } from 'react'
import { IControlProps } from './types'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'
import { HazardAutoComplete } from './HazardAutoComplete'
import { ILabelAndValue } from '../..'


export const AUTOCOMPLETE_CONTROL_TYPES = ['hazard'] as const

// 'hazard' | 'checklist'
export type AutoCompleteFieldName = typeof AUTOCOMPLETE_CONTROL_TYPES[number]

export interface IAutoCompleteControlsProps
  extends IControlProps,
    IOneplaceLibraryContextProp {
  fieldName: AutoCompleteFieldName
  offline: boolean
}

const AutoCompleteControls: React.FC<IAutoCompleteControlsProps> = (props) => {
  const autoCompleteLabel = props.label
  const defaultValue = useMemo(() => {
    const fieldValue = props.options?.find(
      (option) => option.label == props.field.value
    )
    return fieldValue
      ? {
          label: fieldValue.label,
          value: fieldValue.value
        }
      : null
  }, [props.field.value, props.options])

  switch (autoCompleteLabel) {
    case 'hazard':
      return (
       <HazardAutoComplete<ILabelAndValue, string>
          initialSelection={defaultValue as unknown as ILabelAndValue}
          selectionLists={props.options}
          handleHazardChange={(_e, newHazard) => {
            if (props.onFieldChange) {
              props.onFieldChange(props.field.value, newHazard, props.form)
            } else {
              // for incident v2
              props.form.setFieldValue(props.field.name, newHazard)
            }
          }}
          getLabel={(o) => o.label}
          getValue={(o) => o.value}
          mapResponse={(h) => ({ label: h.name, value: h.id })}
          mapOfflineItem={(h) => ({ label: h.label, value: h.value })}
          isOffline={props.offline}
          disabled={!!props.disabled}
          noLabel={true}
          fullWidth={true}
        />
      )
    default: {
      // Exhaustive check – will error at compile time if a new type is added
      const _exhaustiveCheck = autoCompleteLabel
      return <div>This {_exhaustiveCheck} autocomplete is not supported</div>
    }
  }
}

export default withOneplaceLibraryContext(AutoCompleteControls)
